export default "__VITE_ASSET__6af4db51__"